<template>
  <VChip
    v-if="textKey"
    class="rounded ml-2"
    :class="color"
  >
    <VIcon color="textPrimary">
      {{ icon }}
    </VIcon>
    <span class="ml-1">
      {{ $t(textKey) }}
    </span>
  </VChip>
</template>

<script lang="ts">
export default {
  name: 'SPaymentStatusLabel',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import PaymentTypeEnum from '@slg/web-customer-shared/src/enum/PaymentTypeEnum';

const props = defineProps({
  paymentType: {
    required: true,
    type: String,
  },
  isFreeTrip: {
    default: false,
    type: Boolean,
  },
});

const textKey = ref('');
const icon = ref('');
const color = ref('');

if (props.isFreeTrip) {
  textKey.value = 'trips.freeTrip';
  icon.value = 'mdi-check';
  color.value = 'lightGreen';
} else if (props.paymentType === PaymentTypeEnum.ON_BOARD) {
  textKey.value = 'payment.statuses.onBoard';
  icon.value = 'mdi-wallet';
  color.value = 'amber';
} else if (props.paymentType === PaymentTypeEnum.PRE_PAID) {
  textKey.value = 'payment.statuses.paid';
  icon.value = 'mdi-check';
  color.value = 'green lighten-4';
}
</script>
